require('../../modules/es6.object.freeze');
module.exports = require('../../modules/_core').Object.freeze;



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/fn/object/freeze.js